import { COLUMN_BY_KEY, COLUMN_COLOR_SWATCHES, EQUIPMENT_TYPE_OPTIONS } from "../model/materielConstants";
import {
    columnColorBarStyle,
    columnColorSwatchStyle,
    customColorInputStyle,
    customColorLabelStyle,
    filterBarStyle,
    filterInputStyle,
    filterLabelStyle,
    primaryButtonStyle,
    secondaryButtonStyle,
    viewModeButtonStyle,
    viewModeControlStyle,
} from "../styles/materielStyles";

// Titre, nombre de lignes (filtrées / total), format d'affichage et actions du tableau de suivi.
export function FollowUpHeader({ rows, filters, savingId, viewMode, setViewMode, isSuperAdmin, onImport, refresh, onAdd }) {
    const { filtersActive, filteredRows } = filters;
    return (
        <div style={{ padding: "12px 18px", display: "flex", alignItems: "center", gap: "10px", borderBottom: "1px solid #f1f5f9" }}>
            <strong style={{ fontSize: "14px", color: "#0f172a" }}>Tableau de suivi</strong>
            <span style={{ borderRadius: "999px", background: "#f1f5f9", color: "#475569", padding: "2px 8px", fontSize: "12px", fontWeight: 700 }}>
                {filtersActive ? `${filteredRows.length} / ${rows.length}` : rows.length}
            </span>
            <div style={{ flex: 1 }} />
            {savingId && <span style={{ color: "#64748b", fontSize: "12px" }}>Enregistrement...</span>}
            <div style={viewModeControlStyle} aria-label="Format d'affichage">
                <button type="button" onClick={() => setViewMode("vertical")} style={viewModeButtonStyle(viewMode === "vertical")}>Vertical</button>
                <button type="button" onClick={() => setViewMode("table")} style={viewModeButtonStyle(viewMode === "table")}>Tableau</button>
            </div>
            {isSuperAdmin === true && <button onClick={onImport} style={secondaryButtonStyle}>Importer Excel</button>}
            <button onClick={refresh} style={secondaryButtonStyle}>Actualiser</button>
            <button onClick={onAdd} disabled={savingId === "new"} style={primaryButtonStyle}>Ajouter</button>
        </div>
    );
}

export function FollowUpFilters({ filters }) {
    const { patientFilter, setPatientFilter, equipmentTypeFilter, setEquipmentTypeFilter, filtersActive, resetFilters } = filters;
    return (
        <div style={filterBarStyle}>
            <label style={filterLabelStyle}>
                Patient
                <input
                    type="search"
                    value={patientFilter}
                    onChange={event => setPatientFilter(event.target.value)}
                    placeholder="Nom ou prénom"
                    style={filterInputStyle}
                />
            </label>
            <label style={filterLabelStyle}>
                Type de matériel
                <select value={equipmentTypeFilter} onChange={event => setEquipmentTypeFilter(event.target.value)} style={filterInputStyle}>
                    <option value="">Tous les matériels</option>
                    {EQUIPMENT_TYPE_OPTIONS.filter(Boolean).map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select>
            </label>
            {filtersActive && (
                <button type="button" onClick={resetFilters} style={secondaryButtonStyle}>
                    Réinitialiser
                </button>
            )}
        </div>
    );
}

// Couleur de la colonne sélectionnée dans le format tableau : nuancier, couleur libre ou retrait.
export function ColumnColorBar({ colors }) {
    const { columnColors, selectedColumn, savingColumnColor, setColumnColor, clearColumnColor } = colors;
    return (
        <div style={columnColorBarStyle}>
            <strong style={{ color: "#334155", fontSize: "12px" }}>
                Colonne : {COLUMN_BY_KEY[selectedColumn]?.label}
            </strong>
            {COLUMN_COLOR_SWATCHES.map(color => (
                <button
                    key={color}
                    type="button"
                    aria-label={`Appliquer la couleur ${color}`}
                    title={color}
                    onClick={() => setColumnColor(color)}
                    disabled={savingColumnColor}
                    style={columnColorSwatchStyle(color, columnColors[selectedColumn] === color)}
                />
            ))}
            <label style={customColorLabelStyle}>
                Couleur personnalisée
                <input
                    type="color"
                    value={columnColors[selectedColumn] || "#FFFFFF"}
                    onChange={event => setColumnColor(event.target.value)}
                    disabled={savingColumnColor}
                    style={customColorInputStyle}
                />
            </label>
            {columnColors[selectedColumn] && (
                <button type="button" onClick={clearColumnColor} disabled={savingColumnColor} style={secondaryButtonStyle}>
                    Retirer la couleur
                </button>
            )}
            {savingColumnColor && <span style={{ color: "#64748b", fontSize: "12px" }}>Enregistrement...</span>}
        </div>
    );
}
